module.exports = __webpack_public_path__ + "static/media/mercury.8b362d42.svg";